// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): ОБЛЕГЧЁННОЕ МОНОХРОМНОЕ МЕНЮ ЛЕВОГО ВЕРХНЕГО УГЛА ВИДЖЕТА
// (Widget.vue, форма угла: commandPanel_topLeft1 + commandPanel_Scale + ряд W / H / Free). Решение Игоря 03.11 по макетам p222b (B1) с поправкой того же дня
// («давай вместо А1 добавим в B1 кнопку с выбором вариантов если она есть, а в B1 уберем "..." … все команды будут доступны в форме меню»):
//   1) наведение на угол — ОДИН ряд частых команд в стиле правых верхних кнопок (.widget-corner-btn): Закрити · Розгорнути на всю сторінку · Закрити інші ·
//      Згорнути · Копіювати посилання · Відкрити запис у новій вкладці · Клонувати (CORNER_ROW_KEYS) · [Налаштування й варіанти — только у виджета с выбором
//      настроек / вариантов, cornerVariants_on]; «⋯» и полной формы нет;
//   2) все прочие команды формы (Reload, Pop-out / Dock back, Full screen, Header / Tabs / Panel / Float, Size 1–8, W / H %, Free) — в меню виджета «≡»,
//      раздел «Layout» (cornerLayoutMenu); пункт «Width / height, % of page…» открывает у угла ряд с полями W / H / X / Y и Free.
// Горячие клавиши (Alt W / F / M / L / P, Alt 1–8, Shift Alt F) живут как раньше: их ищет store.runActionForHotKey по данным панелей, а не по видимым кнопкам.
// Выключатель — настройка базы / браузера fe.ux.widgetCornerMenuLite (по умолчанию ВКЛ; false — прежняя форма целиком, раздела «Layout» в ≡ нет);
// мобильный профиль не трогается (там своя форма по тапу). Чистые функции без Vue и стора — tests/unit/widgetCornerMenuLite.test.mjs.

export const CORNER_MENU_LITE_FLAG = 'fe.ux.widgetCornerMenuLite'

// механизм включён: десктоп и настройка не выключена явным false
export function cornerMenuLite_on(store) {
    try {
        if (!store) return true
        if (store.mobileUi && store.mobileUi.on) return false
        return typeof store.setting !== 'function' || store.setting(CORNER_MENU_LITE_FLAG, true) !== false
    } catch (e) { return true }
}

// ключ команды кнопки формы: command[:method][:param] (у масштаба — :WxH)
export function cornerCmd_key(a) {
    if (!a || typeof a !== 'object') return ''
    let k = String(a.command || '')
    if (a.method) k += ':' + a.method
    if (a.command === 'onToggleView__Click' && a.param) k += ':' + a.param
    if (a.command === 'onScale__Click' && a.params) k += ':' + a.params.widthMin_rem + 'x' + a.params.heightMin_rem
    return k
}

const SCALE_KEYS = ['1x1', '2x1', '3x1', '4x1', '1x2', '2x2', '3x2', '4x2'].map(s => 'onScale__Click:' + s)
const VIEW_KEYS = ['hideHeader', 'hideTabs', 'hideGridPanel', 'floatHeader'].map(s => 'onToggleView__Click:' + s)

// ряд при наведении — порядок Игоря 03.11
export const CORNER_ROW_KEYS = [
    'onCloseWindow__Click',             // Закрити (Alt W)
    'onWidgetMaxToggle__Click',         // Розгорнути віджет на всю сторінку (Alt F)
    'onCloseOthersWindow__Click',       // Закрити інші
    'onMinimizeWidget__Click',          // Згорнути (Alt M)
    'externalLink:copyToClipboard',     // Копіювати посилання
    'externalLink:openInNewTab',        // Відкрити запис у новій вкладці
    'onCloneRecord__Click',             // Клонувати (Alt L)
]

// раздел «Layout» меню ≡: команды, которых нет в ряду (частые команды ряда в нём не повторяются)
export const CORNER_LAYOUT_KEYS = ['executeWidgetMethod:reload', 'onPopOut_DockBack__Click', 'onFullscreen__Click', ...VIEW_KEYS, 'size', 'layoutPct', 'free']

// кнопки панелей одним списком, без скрытых (hide: true — «Settings tree», Esc, Minimize при fe.ux.widgetMinimize = false, «Close child widgets» без детей)
export function cornerAttrs_flat(...panels) {
    const out = []
    const walk = (x) => {
        if (Array.isArray(x)) { for (const y of x) walk(y); return }
        if (x && typeof x === 'object' && x.hide !== true) out.push(x)
    }
    for (const p of panels) walk(p)
    return out
}

// первая видимая кнопка с ключом (у Esc и «Close Widget» одна команда — Esc скрыт и не берётся)
const byKey = (list) => {
    const m = new Map()
    for (const a of list) { const k = cornerCmd_key(a); if (k && !m.has(k)) m.set(k, a) }
    return m
}

// ряд при наведении: кнопки в порядке CORNER_ROW_KEYS (нет кнопки — её места нет)
export function cornerRow(topLeft1, scale) {
    const m = byKey(cornerAttrs_flat(topLeft1, scale))
    return CORNER_ROW_KEYS.map(k => m.get(k)).filter(Boolean)
}

// кнопка «Налаштування й варіанти» в конце ряда: у виджета есть панель Settings | Variants (dropdownApplies) и в ней есть что выбрать (dropdownTabs)
export function cornerVariants_on(applies, tabsCount) { return !!applies && Number(tabsCount) > 0 }

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: замечания к углу виджета 03.11): панель Settings | Variants — у записи-виджета (WIDGET-*), читается ЖИВЬЁМ при каждом открытии ряда.
// WIDGET — сырой объект стора: computed dropdownApplies, вычисленный до прихода записи (segment ещё пуст), оставался false навсегда — у «Баланс постачання та попиту» на DM
// кнопки вариантов в ряду не было (проба p226 dev02, тот же виджет: r8 — segment-title-static, 7 кнопок; r9 — 8 кнопок с вариантами)
export function widgetSettings_applies(W) {
    const seg = String((W && ((W.record && W.record.segment) || W.segment)) || '')
    return seg.startsWith('WIDGET')
}

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: замечания к углу виджета 03.11): ряд прижат к левому верхнему краю виджета, «Закрити» (первая кнопка) — под точкой курсора, открывшего ряд.
// pt — курсор (clientX / Y), wr — прямоугольник виджета. Центр первой кнопки от угла рамки ряда: 1 px рамки + 4 / 3 px поля (+1 px центровки в ряду 28 px) + 13 px полкнопки = 18 px.
// Сдвиг рамки — в пределах [-2 … 6] px от угла виджета (ряд остаётся прижатым); курсора нет или он не у угла (правый клик по шапке, клавиши) — рамка в углу (0, 0)
export const CORNER_PIN = { off: 18, min: -2, max: 6, near: 48 }
export function cornerPin_place(pt, wr, k = CORNER_PIN) {
    const clamp = (v) => Math.max(k.min, Math.min(k.max, Math.round(v)))
    if (!wr || !pt || typeof pt.x !== 'number' || typeof pt.y !== 'number') return { left: 0, top: 0, why: 'no-pointer' }
    const px = pt.x - wr.left, py = pt.y - wr.top
    if (!(px >= -4 && py >= -4 && px <= k.near && py <= k.near)) return { left: 0, top: 0, why: 'far' }
    return { left: clamp(px - k.off), top: clamp(py - k.off), why: 'pointer' }
}

// иконка кнопки (primeicons / ie-ico) для пункта меню — те же глифы, что у кнопки формы
export function cornerIcon(a) {
    const c = String((a && a.cssClass) || '')
    const keep = c.split(/\s+/).filter(x => /^(pi-[\w-]+|ie-ico-[\w-]+)$/.test(x) && x !== 'pi-expand')
    return keep.length ? 'pi ' + keep.join(' ') : ''
}

// пункт меню из кнопки формы: копия только полей действия (кнопка формы не меняется), без hide и v-if
const itemOf = (a, extra = {}) => ({
    title: a.title || a.tooltip || '', tooltip: a.tooltip || '', hotkey: a.hotkey || '', cssClass: cornerIcon(a),
    command: a.command, method: a.method, params: a.params ? { ...a.params } : undefined, uiHelp: a.uiHelp,
    record_sendToBackend_exclude: a.record_sendToBackend_exclude ? [...a.record_sendToBackend_exclude] : undefined,
    _key: 'Layout/' + cornerCmd_key(a), ...extra,
})

// раздел «Layout» меню ≡: папка { title, titleAction, _key: 'Layout', attrs }. state — геттеры состояния переключателей (header / tabs / panel / float / free):
// пункты-флажки формы-меню (utils/menuParams.js, param.type 'check'); выбор → команда виджета executeWidgetObjMethod (cornerMenu_toggleView / cornerMenu_free /
// cornerMenu_openPct в Widget.vue). Reload (сбросить несохранённые правки) — в форме был только у изменённой записи, в меню — всегда (у неизменённой — перечитать).
// Нет ни одной команды — null
export function cornerLayoutMenu(topLeft1, scale, t = (s) => s, state = {}) {
    const m = byKey(cornerAttrs_flat(topLeft1, scale))
    const attrs = []
    for (const k of ['executeWidgetMethod:reload', 'onPopOut_DockBack__Click', 'onFullscreen__Click']) { const a = m.get(k); if (a) attrs.push(itemOf(a)) }
    const views = [['hideHeader', 'header'], ['hideTabs', 'tabs'], ['hideGridPanel', 'panel'], ['floatHeader', 'float']]
    for (const [v, s] of views) {
        const a = m.get('onToggleView__Click:' + v)
        if (!a) continue
        attrs.push({
            title: a.title || a.tooltip || v, tooltip: a.tooltip || '', _key: 'Layout/view:' + v, uiHelp: a.uiHelp,
            command: 'executeWidgetObjMethod', method: 'cornerMenu_toggleView', view: v,
            param: { type: 'check', value: typeof state[s] === 'function' ? state[s] : () => false },
        })
    }
    const sizes = SCALE_KEYS.map(k => m.get(k)).filter(Boolean)
    // IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета): state.sizeGrid (Widget.vue, флаг fe.ux.widgetMenuSizeGrid) — папка рисуется в MenuPanel
    // одной строкой: сетка 4×2 миниатюр + поля W / H (utils/widgetMenuSize.js); пункты-масштабы (_sizeCell) остаются в данных — поиск, Alt-подсказки и Enter по найденному как раньше
    const grid = (state.sizeGrid && typeof state.sizeGrid === 'object') ? state.sizeGrid : null
    if (sizes.length) attrs.push({ title: t('Size'), titleAction: t('Size'), _key: 'Layout/size', cssClass: 'pi pi-th-large', attrs: sizes.map(a => itemOf(a, grid ? { _sizeCell: true } : {})), ...(grid ? { sizeGrid: grid } : {}) })
    if (attrs.length) {
        attrs.push({ title: t('Width / height, % of page…'), tooltip: t('Fields of the width, height and position at the widget corner'), _key: 'Layout/layoutPct', cssClass: 'pi pi-sliders-h',
            command: 'executeWidgetObjMethod', method: 'cornerMenu_openPct' })
        attrs.push({ title: t('Free'), tooltip: t('Free position (pop-out): the widget floats over the page'), _key: 'Layout/free',
            command: 'executeWidgetObjMethod', method: 'cornerMenu_free',
            param: { type: 'check', value: typeof state.free === 'function' ? state.free : () => false } })
    }
    if (!attrs.length) return null
    return { title: t('Layout'), titleAction: t('Layout'), _key: 'Layout', attrs }
}

// уже есть раздел «Layout» (повторная сборка меню) — не дублировать
export function cornerLayout_has(menu) { return Array.isArray(menu) && menu.some(x => x && x._key === 'Layout') }

export const stats = { rowOpened: 0, pctOpened: 0, variants: 0, kindIconClicks: 0, place: {}, pin: null }
if (typeof window !== 'undefined') window.__cornerMenuLite = stats   // счётчики для проб
